/**
 * PDFViewerPanelHeader Component - Panel header
 *
 * Extracted from PDFViewerPanel.tsx
 */

import React from 'react';
import { FileText, X } from 'lucide-react';
import type { Theme } from '../../themes/theme';

interface PDFViewerPanelHeaderProps {
  onClose?: () => void;
  theme: Theme;
}

export const PDFViewerPanelHeader: React.FC<PDFViewerPanelHeaderProps> = ({ onClose, theme }) => {
  return (
    <div
      className={`flex-shrink-0 border-b ${theme.colors.border.primary} pl-3 pr-1 py-2 flex items-center justify-between gap-2 h-12 overflow-hidden`}
    >
      <div className="flex items-center gap-2 min-w-0">
        <FileText className={`w-3.5 h-3.5 flex-shrink-0 ${theme.colors.text.primary}`} />
        <span className={`text-xs font-semibold ${theme.colors.text.primary} leading-tight`}>
          Visor PDF
        </span>
      </div>
      <div className="flex items-center gap-1">
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className={`min-w-[32px] min-h-[32px] p-1.5 rounded-lg ${theme.colors.bg.secondary} ${theme.colors.text.secondary} hover:${theme.colors.bg.tertiary} transition-colors flex items-center justify-center border ${theme.colors.border.primary}`}
            title="Cerrar panel"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};
